import { Route, Routes } from 'react-router-dom';
import {
    adminPaths,
    supervisorPaths,
    unauthenticatedPaths,
    userPaths,
} from './constants/route-paths';
import { lazy, Suspense } from 'react';
import { DisplayReleaseChanges } from './middlewares/DisplayReleaseChanges';
import { Loader } from '../components/shared/loader/Loader';
import { ScrollToTop } from '../components/shared/ScrollToTop';
import { UnauthenticatedRoutes } from './routes/UnauthenticatedRoutes';
import { NestedPathKeeper } from './middlewares/NestedPathKeeper';
import { HelpRoutes } from './routes/HelpRoute';

const UserRoutes = lazy(() => import('./routes/UserRoutes'));
const SupervisorRoutes = lazy(() => import('./routes/SupervisorRoutes'));
const AdminRoutes = lazy(() => import('./routes/AdminRoutes'));

export const SuSyRouter = () => {
    return (
        <ScrollToTop>
            <Suspense fallback={<Loader />}>
                <NestedPathKeeper>
                    <DisplayReleaseChanges>
                        <Routes>
                            <Route
                                path={unauthenticatedPaths.base}
                                element={<UnauthenticatedRoutes />}
                            ></Route>
                            <Route
                                path={unauthenticatedPaths.help}
                                element={<HelpRoutes />}
                            ></Route>
                            <Route
                                path={userPaths.base}
                                element={<UserRoutes />}
                            ></Route>
                            <Route
                                path={supervisorPaths.base}
                                element={<SupervisorRoutes />}
                            ></Route>
                            <Route
                                path={adminPaths.base}
                                element={<AdminRoutes />}
                            ></Route>
                        </Routes>
                    </DisplayReleaseChanges>
                </NestedPathKeeper>
            </Suspense>
        </ScrollToTop>
    );
};
